var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Vue, Component, Prop } from "vue-facing-decorator";
import Sorter from "@/common/utils/sorter";
import SortableColumn from "@/common/utils/sortable-column";
let SortableColumnComponent = class SortableColumnComponent extends Vue {
    created() {
    }
    ;
    changeSort() {
        this.sorter.sort(this.column);
    }
    ;
    get title() {
        return this.column ? (this.column.title || "") : "";
    }
    ;
    get cssClass() {
        if (!this.sorter)
            return "";
        return this.sorter.columnClass(this.column.fieldName);
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof SortableColumn !== "undefined" && SortableColumn) === "function" ? _a : Object)
], SortableColumnComponent.prototype, "column", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Sorter !== "undefined" && Sorter) === "function" ? _b : Object)
], SortableColumnComponent.prototype, "sorter", void 0);
SortableColumnComponent = __decorate([
    Component({
        name: "SortableColumnComponent",
    })
], SortableColumnComponent);
export default SortableColumnComponent;
